import React, { useState } from 'react'
import NewActionMenu from 'components/ContentBox/Global/ActionMenu/ActionMenu'
import styles from './RowCertificate.module.scss'
import ActionMenu from 'components/UI/ActionMenu/ActionMenu'

const RowCertificate = ({ certificate, index, action, translate }) => {
  const [expanded, setExpanded] = useState(false)

  const toggleExpand = () => {
    setExpanded(!expanded)
  }

  const menu = [
    { name: translate.edit, action: 'edit' },
    { name: translate.delete, action: 'delete' },
  ]

  return (
    <>
      <div
        className={`${styles.clientContainer} ${index % 2 === 0 ? styles.colorBg : ''} ${expanded && styles.colorBgActive}`}
      >
        <div className={styles.containerInf}>
          <div
            className={`${styles.infStyl} ${styles.name} ${expanded ? styles.expClr : styles.notExpClr}`}
          >
            {certificate.name}
          </div>
          <div className={styles.buttons}>
            <NewActionMenu variant='simple' onSimpleAction={toggleExpand} />
            <ActionMenu menu={menu} action={action} items={certificate} />
          </div>
        </div>
      </div>
      {expanded && (
        <div className={styles.clientDetails}>
          <div className={`${styles.formField} `}>
            <div className={styles.label}>{translate.name}:</div>
            <div className={styles.info}>{certificate.name}</div>
          </div>
          <div className={`${styles.formField} `}>
            <div className={styles.label}>{translate.certificate_amount}:</div>
            <div className={styles.info}>{certificate.amount}</div>
          </div>
        </div>
      )}
    </>
  )
}

export default RowCertificate
